function getTimeUntilNext12PM() {
    const currentTime = new Date();
    const targetTimeZone = "America/Los_Angeles";
  
    const targetTime = new Date();
    targetTime.setHours(12, 0, 0, 0);

    const currentTimeAtWarehouse = new Date(
      currentTime.toLocaleString("en-US", { timeZone: targetTimeZone })
    );
    const localTimezone = new Date(
      currentTime.toLocaleString("en-US")
    );
    const targetTimeAtWarehouse = new Date(
      targetTime.toLocaleString("en-US", { timeZone: targetTimeZone })
    );
    const timeDifference = localTimezone - currentTimeAtWarehouse;

    var timeUntilTarget = targetTimeAtWarehouse - currentTimeAtWarehouse + timeDifference;
    if (timeUntilTarget > 24 * 60 * 60 * 1000) {
      timeUntilTarget -= 24 * 60 * 60 * 1000;
    }
    else if(timeUntilTarget < 0){
      timeUntilTarget += 24 * 60 * 60 * 1000;
    }

    const targetDate = new Date(localTimezone.getTime() + timeUntilTarget);
    const totalSeconds = Math.floor(timeUntilTarget / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return {
      currentDay: localTimezone.getDay(),
      targetDay: targetDate.getDay(), 
      hours: hours,
      minutes: minutes,
      seconds: seconds
    };
  }
  
  setInterval(function() {
    var remainingTime = getTimeUntilNext12PM();
    printText(remainingTime)
  }, 1000);

  function printText(remainingTime){
    var orderWithin = document.getElementById("orderWithin");
    if((remainingTime.targetDay <= 5) && remainingTime.currentDay == remainingTime.targetDay){
      orderWithin.innerHTML = `<span style="font-weight: bold">Order within</span> <span class="timeRemaining">${remainingTime.hours}h ${remainingTime.minutes}m ${remainingTime.seconds}s</span> to have your order shipped today.`;
    }
    else if((remainingTime.targetDay <= 5 && remainingTime.currentDay <= 4)){
      orderWithin.innerHTML = `<span style="font-weight: bold">Order within</span> <span class="timeRemaining">${remainingTime.hours}h ${remainingTime.minutes}m ${remainingTime.seconds}s</span> to have your order shipped tomorrow.`;
    }
    else{
      orderWithin.innerHTML = `Order will be shipped on <span style="font-weight: bold">Monday</span>.`;
    }
}
  

